

















































































































import { Component, Vue } from "vue-property-decorator";
import { Button, Toast, Popup, Picker, Loading, Icon, Checkbox } from "vant";
import customField from "@/components/customField/index.vue";
import { isChinaPhone, isHKPhone } from "@/utils/verify";
import GlobalActionSheet from "@/components/GlobalActionSheet.vue";
import {
  buildAreaCodePickerOptions,
  initDefaultAreaCode,
  getAreaCodePickerIndex
} from "@/utils/areaCodeList";

@Component({
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    customField: customField,
    [Checkbox.name]: Checkbox,
    GlobalActionSheet
  }
})
export default class Login extends Vue {
  form: any = {
    zone_code: "852",
    phone: "",
    captcha: "",
    code: "",
    key: "",
    area_code_id: "" // 新增区号ID
  };
  img = "";
  isSendVerCode = false;
  verCodeTime = 120;
  verCodeTimer: any = null;
  showZoneCodePicker = false;
  currentZoneCodeIndex = 0; // 新增：当前区号选中的索引
  isCaptchaLoading = true;
  isCaptchaError = false;
  isAgree = false;
  showGlobalSheet = false;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }
  get isDisabledSubmit() {
    let flag = false;
    for (const key in this.form) {
      if (!this.form[key] && key !== "key") {
        flag = true;
        break;
      }
    }
    return flag;
  }

  get zoneCodeColumns() {
    return buildAreaCodePickerOptions(this.$i18n);
  }

  created() {
    initDefaultAreaCode(this.form);
    this.currentZoneCodeIndex = getAreaCodePickerIndex(
      this.zoneCodeColumns,
      this.form.area_code_id
    );
    this.handleGetCaptcha();
  }

  handleGetCaptcha() {
    this.isCaptchaLoading = true;
    this.isCaptchaError = false;
    (this as any).$apis
      .getCaptcha()
      .then(res => {
        
        this.isCaptchaLoading = false;
        const { key, img } = res;
        this.form.key = key;
        this.img = img;
      })
      .catch(e => {
        this.isCaptchaLoading = false;
        this.isCaptchaError = true;
        
      });
  }

  handleConfirmZoneCode(item) {
    this.form.zone_code = item.value;
    this.form.area_code_id = item.id; // 同时保存区号ID
    this.showZoneCodePicker = false;
  }

  // 新增：计算当前区号选中的索引
  calculateZoneCodeIndex() {
    const index = this.zoneCodeColumns.findIndex(
      item => item.value == this.form.zone_code
    );
    this.currentZoneCodeIndex = index >= 0 ? index : 0;
  }

  verifyPhone() {
    if (this.form.zone_code == "86") {
      return isChinaPhone(this.form.phone);
    } else if (this.form.zone_code == "852") {
      return isHKPhone(this.form.phone);
    }
  }

  handleSendVerCode() {
    const { captcha, key } = this.form;
    // if (!this.verifyPhone())
    //   return this.$toast.fail(this.$t("common.phone_verify_fail_text"));
    if (!this.form.captcha)
      return this.$toast.fail(this.$t("common.captcha_verify_fail_text"));
    const params = {
      captcha,
      key
    };
    (this as any).$apis
      .verifyCaptcha(params)
      .then((res) => {
        if(!res.code && !res.msg){
          this.sendVerCode();
        }
      })
      .catch(e => {
        
      });
  }

  sendVerCode() {
    const { phone, zone_code, area_code_id } = this.form;
    // if (!this.verifyPhone()) {
    //   return this.$toast.fail(this.$t("common.phone_verify_fail_text"));
    // }
    const params = {
      phone,
      zone_code,
      area_code_id, // 新增区号ID参数
      msg_show: 1,
      type: 2 //1登录，2注册，3找回密码
    };
    (this as any).$apis
      .sendVerCode(params)
      .then(res => {
        
        // 有msg则证明验证码没有发送成功 验证码发送成功在倒计时
        if( res.msg ){
          return false;
        }
        if(res.code && !res.msg){
          this.form.code = res.code;
        }
        Toast(this.$t("common.message_send_success_text"));
        this.isSendVerCode = true;
        this.setIntervalSendCode();
      })
      .catch(e => {
        
      });
  }

  setIntervalSendCode() {
    const now = new Date().getTime();
    const end = new Date(now + this.verCodeTime * 1000).getTime();
    this.verCodeTimer = setInterval(() => {
      this.verCodeTime = Math.ceil((end - new Date().getTime()) / 1000);
      if (this.verCodeTime <= 0) {
        clearInterval(this.verCodeTimer);
        this.verCodeTime = 120;
        this.isSendVerCode = false;
      }
    }, 1000);
  }

  handleSubmit() {
    // if (!this.verifyPhone())
    //   return this.$toast.fail(this.$t("common.phone_verify_fail_text"));
    if (!this.isAgree)
      return this.$toast.fail(this.$t("common.agreement_verify_fail_text"));
    (this as any).$apis
      .checkRegister(this.form)
      .then(res => {
        
        // 返回msg则证明验证码错误
        if ( res.msg ) {
          return this.$toast.fail(res.msg);
        }
        const { zone_code, phone } = this.form;
        this.$router.push({
          path: "/register/password-setting",
          query: {
            zone_code,
            phone,
            ...this.$route.query
          }
        });
      })
      .catch(e => {
        
      });
  }

  onGlobalClose() {
    this.showGlobalSheet = false;
  }
}
